import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';

export const markdownTheme = createTheme({
  theme: 'light',
  settings: {
    background: '#ffffff',
    foreground: '#24292f',
    caret: '#24292f',
    selection: '#b3d4fc',
    selectionMatch: '#b3d4fc',
    lineHighlight: 'transparent',
    gutterBackground: '#ffffff',
    gutterForeground: '#6e7781',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: '14px'
  },
  styles: [
    // Headings
    {
      tag: t.heading1,
      color: '#0d1117',
      fontWeight: '700',
      fontSize: '1.5em'
    },
    {
      tag: t.heading2,
      color: '#0d1117',
      fontWeight: '600',
      fontSize: '1.3em'
    },
    {
      tag: t.heading3,
      color: '#0d1117',
      fontWeight: '600',
      fontSize: '1.15em'
    },
    { tag: t.heading4, color: '#0d1117', fontWeight: '600' },
    { tag: t.heading5, color: '#0d1117', fontWeight: '600' },
    { tag: t.heading6, color: '#57606a', fontWeight: '600' },

    // Emphasis
    { tag: t.emphasis, color: '#24292f', fontStyle: 'italic' },
    { tag: t.strong, color: '#24292f', fontWeight: '600' },
    {
      tag: t.strikethrough,
      color: '#6e7781',
      textDecoration: 'line-through'
    },

    // Links
    { tag: t.link, color: '#0969da', textDecoration: 'underline' },
    { tag: t.url, color: '#0969da' },

    // Code
    {
      tag: t.monospace,
      color: '#0a3069',
      backgroundColor: 'rgba(175, 184, 193, 0.2)',
      fontFamily: '"SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
      fontSize: '85%',
      padding: '0.2em 0.4em'
    },

    // Lists
    { tag: t.list, color: '#24292f' },

    // Quotes
    { tag: t.quote, color: '#57606a', fontStyle: 'italic' },

    // Comments (for code blocks)
    { tag: t.comment, color: '#6e7781', fontStyle: 'italic' }
  ]
});
